<!--<div class="snack-container">-->
  <div class="flex items-start sm:items-center justify-center text-center">
    <mat-icon class="snackIcon">{{ data?.icon }}</mat-icon>
    <span>{{ data?.message }}</span>
  </div>

  <mat-icon class="closeIcon" (click)="closeSnackBar()">close</mat-icon>
<!--</div>-->
